var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Nome da Turma",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.nomeTurma,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nomeTurma", $$v);
      },
      expression: "form.filters.nomeTurma"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Ano/Série",
      "item-text": "nome",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listAnoSeries
    },
    model: {
      value: _vm.form.filters.anoSerie,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "anoSerie", $$v);
      },
      expression: "form.filters.anoSerie"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Turno",
      "item-text": "descricao",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listTurnos
    },
    model: {
      value: _vm.form.filters.turno,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "turno", $$v);
      },
      expression: "form.filters.turno"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "d-flex justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Escola",
      "item-text": "local",
      "item-value": "id",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.listEscolas
    },
    model: {
      value: _vm.form.filters.escola,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "escola", $$v);
      },
      expression: "form.filters.escola"
    }
  })], 1), _c('sca-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicio", $$v);
      },
      expression: "form.filters.dataInicio"
    }
  }), _c('sca-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFim", $$v);
      },
      expression: "form.filters.dataFim"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sca-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": _vm.buscarRelatorios
    }
  }), _c('sca-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": _vm.resetForm
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5 printable",
    attrs: {
      "headers": _vm.headersAnalitico,
      "items": _vm.form.lists.listRelatorios,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps,
      "sort-by": "dataHora",
      "sort-desc": true,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: `item.nomeTurma`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.nomeTurma) + " ")];
      }
    }, {
      key: `item.anoSerie`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.anoSerie) + " ")];
      }
    }, {
      key: `item.turno`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.turno) + " ")];
      }
    }, {
      key: `item.escola`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.escola) + " ")];
      }
    }, {
      key: `item.dataHora`,
      fn: function (_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.dataHora) + " ")];
      }
    }, {
      key: `item.acao`,
      fn: function (_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(item.acao) + " ")];
      }
    }], null, true)
  }), _vm.form.lists.listRelatorios.length ? _c('sca-buttons', {
    attrs: {
      "actionText": "Baixar PDF",
      "cancelText": "Baixar CSV"
    },
    on: {
      "click": _vm.baixarRelatorioPdf,
      "cancel": _vm.baixarCSVRelatorio
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }